import React from "react";
import { TextField, FormGroup } from "@material-ui/core/";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import { FormStyles } from "../../../../styles";

const Identification = props => (
  <div>
    <FormGroup>
      <TextField
        label="Identifiant"
        name={`compteRequestDto[identifiant]`}
        variant="outlined"
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        helperText={
          <span className={props.classes.formError}>
            {props.touched.compteRequestDto &&
              props.touched.compteRequestDto["identifiant"] &&
              props.errors.compteRequestDto &&
              props.errors.compteRequestDto["identifiant"]}
          </span>
        }
        value={props.values.compteRequestDto.identifiant}
      />
    </FormGroup>
    <FormGroup>
      <TextField
        label="Password"
        name={`compteRequestDto[motDePasse]`}
        variant="outlined"
        type="password"
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        helperText={
          <span className={props.classes.formError}>
            {props.touched.compteRequestDto &&
              props.touched.compteRequestDto["motDePasse"] &&
              props.errors.compteRequestDto &&
              props.errors.compteRequestDto["motDePasse"]}
          </span>
        }
        value={props.values.compteRequestDto.motDePasse}
      />
    </FormGroup>
    <FormGroup>
      <TextField
        label="Confirm password"
        name={`compteRequestDto[comfirmerMotDePasse]`}
        variant="outlined"
        type="password"
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        helperText={
          <span className={props.classes.formError}>
            {props.touched.compteRequestDto &&
              props.touched.compteRequestDto["comfirmerMotDePasse"] &&
              props.errors.compteRequestDto &&
              props.errors.compteRequestDto["comfirmerMotDePasse"]}
          </span>
        }
        value={props.values.compteRequestDto.comfirmerMotDePasse}
      />
    </FormGroup>
  </div>
);

Identification.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(FormStyles)(Identification);
